(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const enhanced = new WeakSet();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const enhance = (root) => {
      root.querySelectorAll('[id$="__homepage_faq"] accordion-disclosure').forEach((disclosure) => {
        if (enhanced.has(disclosure)) return;
        enhanced.add(disclosure);
        ['createOpenAnimationControls', 'createCloseAnimationControls'].forEach((method) => {
          const original = disclosure[method];
          if (typeof original !== 'function') return;
          disclosure[method] = function (...args) {
            const controls = original.apply(this, args);
            if (reducedMotion.matches && typeof controls?.complete === 'function') controls.complete();
            return controls;
          };
        });
      });
    };
    customElements.whenDefined('accordion-disclosure').then(() => {
      enhance(document);
      document.addEventListener('shopify:section:load', () => enhance(document));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
